import Account from '@/api/account'
import { Account as AccountModel } from '@/models/Account'

const actions = {
  async GET({ commit }) {
    const res = await Account.getMe()
    const account = res.item
    commit('INITIALIZE', { account: account })
  },
  async SEARCH(
    { commit },
    { keyword, systemOwnerId, agencyId, advertiserId, pageSize, pageNo },
  ) {
    const result = await AccountModel.search({
      keyword,
      systemOwnerId,
      agencyId,
      advertiserId,
      pageSize,
      pageNo,
    })
    commit('SET_SEARCH_RESULT', result)
    return result
  },
  UPDATE_NAME({ commit }, name) {
    commit('UPDATE_NAME', name)
  },
  UPDATE_EMAIL({ commit }, email) {
    commit('UPDATE_EMAIL', email)
  },
  INITIALIZE({ commit }, payload) {
    commit('INITIALIZE', { account: payload })
  },
  async GET_SYSTEM_OWNER({ commit }) {
    const systemOwner = await Account.getSystemOwner()
    commit('INITIALIZE_SYSTEM_OWNER', { systemOwner })
  },
}

export default actions
